/**
 * Toolbar Mobile Manager
 * Manages toolbar interactions - closes existing drawers/popups/modals before opening new ones
 */

(function() {
    'use strict';

    function closeAllDrawersAndModals() {
        // Close all side drawers
        const activeDrawers = document.querySelectorAll('side-drawer.active');
        activeDrawers.forEach(drawer => {
            if (drawer && typeof drawer.close === 'function') {
                drawer.close();
            }
        });

        // Close cart popup
        if (document.body.classList.contains('cart-dropdown-show')) {
            document.body.classList.remove('cart-dropdown-show');
        }

        // Close cart sidebar
        if (document.body.classList.contains('cart-sidebar-show')) {
            document.body.classList.remove('cart-sidebar-show');
        }

        // Close auth popup
        if (document.body.classList.contains('auth-popup-show')) {
            document.body.classList.remove('auth-popup-show');
        }

        // Close auth sidebar
        if (document.body.classList.contains('auth-sidebar-show')) {
            document.body.classList.remove('auth-sidebar-show');
        }

        // Close all modals
        const openModals = document.querySelectorAll('custom-modal[open]');
        openModals.forEach(modal => {
            if (modal && typeof modal.hide === 'function') {
                modal.hide();
            }
        });

        // Remove open-drawer body class
        if (document.body.classList.contains('open-drawer')) {
            document.body.classList.remove('open-drawer');
        }

        // Remove overflow-hidden if no other modals are open
        const hasOpenModals = document.querySelectorAll('custom-modal[open]').length > 0;
        const hasOpenDrawers = document.querySelectorAll('side-drawer.active').length > 0;
        if (!hasOpenModals && !hasOpenDrawers) {
            document.body.classList.remove('overflow-hidden');
        }
    }

    function initToolbarManager() {
        const toolbar = document.querySelector('.halo-toolbar-mobile');
        if (!toolbar) return;

        // Handle all toolbar item clicks
        toolbar.addEventListener('click', function(event) {
            const toolbarItem = event.target.closest('.halo-toolbar-item');
            if (!toolbarItem) return;

            // Check if it's an actionable element
            const isCartAction = event.target.closest('[data-open-cart-popup], [data-cart-sidebar]');
            const isAuthAction = event.target.closest('[data-open-auth-popup], [data-open-auth-sidebar]');
            const isDrawerOpener = event.target.closest('side-drawer-opener');
            const isModalOpener = event.target.closest('custom-modal-opener');

            if (isCartAction || isAuthAction || isDrawerOpener || isModalOpener) {
                // Close everything first
                closeAllDrawersAndModals();
            }
        }, true); // Use capture phase
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initToolbarManager);
    } else {
        initToolbarManager();
    }
})();
